export default {
  "content": "<title>Flame</title><path d=\"M112 320c0-93 124-165 96-272 66 0 192 96 192 272a144 144 0 01-288 0z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M320 368c0 57.71-32 80-64 80s-64-22.29-64-80 40-86 32-128c42 0 96 70.29 96 128z\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};